import { type Language } from '@/models/common/Language';
import { LanguageId } from '@/enums/enums';

export const languages: Language[] = [
  { id: LanguageId.English, code: 'en', language: 'English' },
  { id: LanguageId.Arabic, code: 'ar', language: 'عربي' },
];
